import { Box } from "@mui/material";
import React from "react";
import PageTitle from "../base/PageTitle";
import ScheduledReportsView from "../views/Reports/ScheduledReportsView";

interface Props {}

const ReportsPage: React.FC<Props> = (props) => {
  return (
    <Box>
      <PageTitle title="Scheduled Reports" />
      <ScheduledReportsView />
    </Box>
  );
};

export default ReportsPage;
